import { useMemo } from 'react';
import type { LessonObjective } from '@teachur/http-client';
import { useCurrentUser } from '@hooks/users';

export const useLessonProgress = (objectives: LessonObjective[] = []) => {
  const { data: user } = useCurrentUser();

  const progress = useMemo(() => {
    if (!objectives || objectives.length === 0) {
      return 0;
    }

    if (!user || !user.completedObjectives) {
      return 0;
    }

    const completedCount = objectives.filter((objective) =>
      user.completedObjectives?.some((completed) => completed.id === objective.id)
    ).length;

    return Math.round((completedCount / objectives.length) * 100);
  }, [objectives, user]);

  return progress;
};
